import type { RichOption } from '@liscio/api';

/** Status values excluded from account creation (onboarding / create flows). */
const EXCLUDED_STATUS_KEYS = new Set(['inactive']);

export function filterCreateAccountStatusOptions(
  options: RichOption[] | undefined
): RichOption[] | undefined {
  if (!options?.length) {
    return options;
  }

  return options.filter((option) => {
    const normalized = String(option.key ?? option.value ?? '').toLowerCase();
    return !EXCLUDED_STATUS_KEYS.has(normalized);
  });
}
